import { useEffect } from 'react';
import secureStorage from '@src/config/encrypt';
import { useNavigate } from 'react-router';

const PrivateRoute = ({ component: Component, ...rest }: any) => {
    const authUserInfo = secureStorage.getItem('authAgentUserInfo');
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to login if the user is not logged in
        if (!authUserInfo) {
            navigate('/login', { replace: true });
        }
    }, [authUserInfo, navigate]);

    // Ensure the component is valid and render it with rest props
    return authUserInfo && Component ? <Component {...rest} /> : null;
};

export default PrivateRoute;
